import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#3F51B5',
        secondary: '#525F7F',
        lightBlue: '#E6F0FF',
        darkBlue: '#1868FB',
        defaultGrey: '#E3E8EE',
        background: '#F5F9FC',
        blueCard: '#000000',
        blueFont: '#6B7C93',
        radioLabel: '#525F7F'
      }
    }
  }
})
